import { render, staticRenderFns } from "./LatestDevelopments.vue?vue&type=template&id=de4c74be&scoped=true&"
import script from "./LatestDevelopments.vue?vue&type=script&lang=js&"
export * from "./LatestDevelopments.vue?vue&type=script&lang=js&"
import style0 from "./LatestDevelopments.vue?vue&type=style&index=0&id=de4c74be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c74be",
  null
  
)

export default component.exports